import { IonContent, IonPage } from '@ionic/react';
import { useHistory } from 'react-router-dom';
// import Container from '../components/Container';

const Home: React.FC = () => {
  const history = useHistory();
  const btnHandler = () => {
    // route to /app-academy
    history.push("/app-academy");
  }
  return (
    <IonPage className='home'>
      <IonContent fullscreen className='container'>
        <h1>Apa sih kerennya<br />School of Swipe™?</h1>
        <p style={{ lineHeight: '1.2' }}>Yuk kenali definisi swipe (geser), match (jodoh), ghosting, sampai thirsting, dan banyak hal lainnya, ada berbagai ilmu berkencan lainnya yang bisa kamu pelajari. Selangkah lebih maju dan tingkatkan wawasanmu supaya semakin mantap ngedeketin si dia.<br />Sudah siap belajar berkencan? Yuk, kelasnya sudah mulai.</p>
        <button className='white-btn' onClick={() => btnHandler()} style={{ zIndex: '105', marginTop: '1rem' }}>Ayo!</button>
      </IonContent>
    </IonPage>
  );
};

export default Home;